// extracted by mini-css-extract-plugin
export default {"label":"jdX4YAC","labelContent":"TmJMl2A"};